/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import { ActivityList, BookingList, ModuleList, OrderList, RoutineList, TransactionList } from 'components';
import React, { lazy } from 'react';
import { Redirect } from 'react-router-dom';
import { AccountDetail, AccountList } from 'views/Account';
import { ActivityDetail } from 'views/Activity';
import AppDownload from 'views/AppDownload';
import { BookingDetail } from 'views/Booking';
import { Changelog, HelpPage } from 'views/Help';
import { InventoryDetail } from 'views/Inventory';
import { InventoryItemDetail } from 'views/InventoryItem';
import { PayOptionDetail } from 'views/PayOption';
import { ItemClassDetail, ItemClassList } from 'views/ItemClass';
import { LessonDetail, LessonList } from 'views/Lesson';
import { MasteryDetail, MasteryList, MasteryOrder } from 'views/Mastery';
import { ModuleDetail } from 'views/Module';
import { NoticeDetail, NoticeList } from 'views/Notice';
import { OrderDetail } from 'views/Order';
import Overview from 'views/Overview';
import { ClassPassDetail, ClassPassList, TopupOptionDetail, TopupOptionList } from 'views/Product';
import { RoutineDetail } from 'views/Routine';
import { SlotDetail } from 'views/Slot';
import { StudentDetail, StudentList } from 'views/Student';
import { TeacherDetail, TeacherList } from 'views/Teacher';
import TeacherOverview from 'views/TeacherOverview';
import { TransactionDetail } from 'views/Transaction';
import { WalletDetail } from 'views/Wallet';
import AuthLayout from './layouts/Auth';
import DashboardLayout from './layouts/Dashboard';
import ErrorLayout from './layouts/Error';

const routes = [{
  path: '/',
  exact: true,
  component: () => <Redirect to="/overview" />
}, {
  path: '/auth',
  component: AuthLayout,
  routes: [{
    path: '/auth/login',
    exact: true,
    component: lazy(() => import('views/Login'))
  }, {
    path: '/auth/password',
    exact: true,
    component: lazy(() => import('views/PasswordRequest'))
  }, {
    path: '/auth/password/reset',
    exact: true,
    component: lazy(() => import('views/PasswordReset'))
  }, {
    component: () => <Redirect to="/auth/login" />
  }]
}, {
  path: '/errors',
  component: ErrorLayout,
  routes: [{
    path: '/errors/error-401',
    exact: true,
    component: lazy(() => import('views/Error401'))
  }, {
    path: '/errors/error-404',
    exact: true,
    component: lazy(() => import('views/Error404'))
  }, {
    path: '/errors/error-500',
    exact: true,
    component: lazy(() => import('views/Error500'))
  }, {
    component: () => <Redirect to="/errors/error-404" />
  }]
}, {
  route: '*',
  component: DashboardLayout,
  routes: [{
    path: '/overview',
    exact: true,
    component: Overview,
  }, {
    path: '/weekly-overview',
    exact: true,
    component: TeacherOverview,
  }, {
    path: '/accounts',
    exact: true,
    component: AccountList,
  }, {
    path: '/accounts/:account_id/:tab',
    exact: true,
    component: AccountDetail
  }, {
    path: '/students',
    exact: true,
    component: StudentList,
  }, {
    path: '/students/:student_id/:tab',
    exact: true,
    component: StudentDetail
  }, {
    path: '/teachers',
    exact: true,
    component: TeacherList,
  }, {
    path: '/teachers/:teacher_id/:tab',
    exact: true,
    component: TeacherDetail
  }, {
    path: '/masteries',
    exact: true,
    component: MasteryList
  }, {
    path: '/masteries/reorder',
    exact: true,
    component: MasteryOrder
  }, {
    path: '/masteries/:mastery_id/:tab',
    exact: true,
    component: MasteryDetail
  }, {
    path: '/modules',
    exact: true,
    component: ModuleList
  }, {
    path: '/modules/:module_id/:tab',
    exact: true,
    component: ModuleDetail
  }, {
    path: '/routines',
    exact: true,
    component: RoutineList
  }, {
    path: '/routines/:routine_id/:tab',
    exact: true,
    component: RoutineDetail
  }, {
    path: '/lessons',
    exact: true,
    component: LessonList
  }, {
    path: '/lessons/:lesson_id/:tab',
    exact: true,
    component: LessonDetail
  }, {
    path: '/lesson_slots/:slot_id/:tab',
    exact: true,
    component: SlotDetail
  }, {
    path: '/bookings',
    exact: true,
    component: BookingList
  }, {
    path: '/bookings/:booking_id/:tab',
    exact: true,
    component: BookingDetail
  }, {
    path: '/wallets/:wallet_id/:tab',
    exact: true,
    component: WalletDetail
  }, {
    path: '/transactions',
    exact: true,
    component: TransactionList
  }, {
    path: '/transactions/:transaction_id/:tab',
    exact: true,
    component: TransactionDetail
  }, {
    path: '/orders',
    exact: true,
    component: OrderList
  }, {
    path: '/orders/:order_id/:tab',
    exact: true,
    component: OrderDetail
  }, {
    path: '/topup-options',
    exact: true,
    component: TopupOptionList
  }, {
    path: '/topup-options/:topup_option_id/:tab',
    exact: true,
    component: TopupOptionDetail
  }, {
    path: '/item-classes',
    exact: true,
    component: ItemClassList
  }, {
    path: '/item-classes/:item_class_id/:tab',
    exact: true,
    component: ItemClassDetail
  }, {
    path: '/class-passes',
    exact: true,
    component: ClassPassList
  }, {
    path: '/class-passes/:class_pass_id/:tab',
    exact: true,
    component: ClassPassDetail
  }, {
    path: '/inventories/:inventory_id/:tab',
    exact: true,
    component: InventoryDetail
  }, {
    path: '/items/:item_id/:tab',
    exact: true,
    component: InventoryItemDetail
  }, {
    path: '/payment-options/:pay_option_id/:tab',
    exact: true,
    component: PayOptionDetail
  }, {
    path: '/activities',
    exact: true,
    component: ActivityList
  }, {
    path: '/activities/:activity_id/:tab',
    exact: true,
    component: ActivityDetail
  }, {
    path: '/notices',
    exact: true,
    component: NoticeList
  }, {
    path: '/notices/:notice_id/:tab',
    exact: true,
    component: NoticeDetail
  }, {
    path: "/app/download",
    exact: true,
    component: AppDownload
  }, {
    path: "/help",
    exact: true,
    component: HelpPage
  }, {
    path: "/help/changelog",
    exact: true,
    component: Changelog
  }, {
    component: () => <Redirect to="/errors/error-404" />
  }]
}];

export default routes;
